<template>
  <div class="fo-attention" role="region" aria-label="Atenção" v-if="items.length > 0">
    <span class="fo-attention-label">
      <fa-icon :icon="['fal', 'exclamation-triangle']"/>Atenção
    </span>
    <template v-for="item in items">
      <router-link class="fo-attention-item" v-if="item.to" :key="item.key" :to="item.to">
        <span>{{ item.label }}</span><strong v-if="item.value">{{ item.value }}</strong>
      </router-link>
      <span class="fo-attention-item" v-else :key="item.key">
        <span>{{ item.label }}</span><strong v-if="item.value">{{ item.value }}</strong>
      </span>
    </template>
  </div>
</template>

<script>
import { money, STATEMENTS_PATH } from './helpers';

export default {
  props: {
    attention: {
      type: Object,
      required: true,
    },
    hidden: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    items() {
      const {
        overdueReceivable, overduePayable, negativeAccounts, staleStatements,
      } = this.attention;
      const items = [];
      if (overdueReceivable > 0) {
        items.push({
          key: 'receivable',
          label: 'Contas a receber vencidas',
          value: money(overdueReceivable, this.hidden),
        });
      }
      if (overduePayable > 0) {
        items.push({
          key: 'payable',
          label: 'Contas a pagar vencidas',
          value: money(overduePayable, this.hidden),
        });
      }
      negativeAccounts.forEach((account) => {
        items.push({
          key: `negative-${account.id}`,
          label: `${account.name} com saldo negativo`,
          value: money(account.balance, this.hidden),
          to: STATEMENTS_PATH,
        });
      });
      staleStatements.forEach((account) => {
        const lines = account.count === 1 ? '1 linha' : `${account.count} linhas`;
        items.push({
          key: `stale-${account.id}`,
          label: `${account.name}: ${lines} do extrato sem conciliar há mais de 7 dias`,
          to: STATEMENTS_PATH,
        });
      });
      return items;
    },
  },
};
</script>
